
const routes = {
    // 公共
    'uninstall.questionnaire': {path: '/uninstall-questionnaire', method: 'POST'},
};

export default routes